// Sciezka do panelu admina — konfigurowalna przez frontend/.env → REACT_APP_ADMIN_PATH.
// Zmieniaj co jakis czas dla bezpieczenstwa (security through obscurity).
export const ADMIN_PATH = process.env.REACT_APP_ADMIN_PATH || "admin";
export const ADMIN_URL = `/${ADMIN_PATH}`;
export const ADMIN_LOGIN_URL = `/${ADMIN_PATH}/login`;
